import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas';
import { NzMessageService } from 'ng-zorro-antd';
import * as jspdf from 'jspdf';

@Component({
  selector: 'app-pay-slip',
  templateUrl: './pay-slip.component.html',
  styleUrls: ['./pay-slip.component.less']
})
export class PaySlipComponent implements OnInit {
  paymentResponse:any
  formData:any;
  constructor(
    private router :Router,
    private message: NzMessageService
  ) { }

  ngOnInit() {
    this.formData = history.state.formData || null; 
    console.log("form data", this.formData)
  }
  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.message.success('copied to clipboard');
  }
  close(){
    this.router.navigate(['/send-payment-link']);
  }

    downloadReceipt() {
      console.log("function called")
    const fileName = 'Receipt of' + ' ' + this.formData.receiverAccountNumber;
    const data = document.getElementById('receipt');
    html2canvas((data), { scale: 2 }).then(canvas => {
  
  // Few necessary setting options
  
  const pdf = new jspdf('p', 'px', 'a3'); // A4 size page of PDF
  const imgWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = 150;
  const imgHeight = pdf.internal.pageSize.getHeight();
  const heightLeft = imgHeight;
  
  const contentDataURL = canvas.toDataURL('image/jpeg');
  const position = 0;
  pdf.addImage(contentDataURL, 'JPEG', 0, position, imgWidth, imgHeight/3);
  pdf.save(fileName); // Generated PDF
  
  });
    // this.receiptService.getPdfForReceipt(this.selectedTransaction.id, 'receipt');
  }

  getStatusIcon(code: number): string {
  if (code === 15 || code === 1) return 'check-circle';
  if (code === 12) return 'loading';
  if (code === 11) return 'check-circle';
  if (code === 8) return 'close-circle';
  if (code === 7) return 'clock-circle';
  return 'loading';
}

getStatusText(code: number): string {
  const map = {
    15: 'Completed',
    12: 'Processing',
    11: 'Received',
    8: 'Failed',
    7: 'Pending',
    1: 'Completed'
  };
  return map[code] || 'Processing';
}
}
